import axios from "axios";
import {
  arcgis_api_key_dev_org,
  arcgis_api_key_ocpw_org,
  esriOauthAppId_AGOL,
  esriOauthAppId_OCPWPORTAL_DEV
} from "../config";

const loadPageConfiguration = async (id, callback): Promise<boolean> => {
  try {
    let res = await axios.get(
      `${process.env.PUBLIC_URL}/pageConfiguration.json`
    );
    //.then(async res => {
    const foundConfig = res.data.find((config) => config.id === id);

    if (foundConfig) {
      if (foundConfig?.esriOauthAppId === "esriOauthAppId_AGOL") {
        foundConfig.esriOauthAppId = esriOauthAppId_AGOL;
      }
      if (foundConfig?.esriOauthAppId === "esriOauthAppId_OCPWPORTAL_DEV") {
        foundConfig.esriOauthAppId = esriOauthAppId_OCPWPORTAL_DEV;
      }
      if (foundConfig?.orgApikey === "arcgis_api_key_dev_org") {
        foundConfig.orgApikey = arcgis_api_key_dev_org;
      }
      if (foundConfig?.orgApikey === "arcgis_api_key_ocpw_org") {
        try {
          let resKey = await axios.get(`${arcgis_api_key_ocpw_org}`);
          foundConfig.orgApikey = resKey.data.apiKey;
        } catch (error) {
          throw new Error("API key fetch failed");
        }
      }
      if (foundConfig?.baseTemplate?.apiKey === "arcgis_api_key_dev_org") {
        foundConfig.baseTemplate.apiKey = arcgis_api_key_dev_org;
      }
      callback(foundConfig);
      return true;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  } //);
};

export const getAllPageConfigurations = async (): Promise<any[]> => {
  try {
    const response = await axios.get(
      `${process.env.PUBLIC_URL}/pageConfiguration.json`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    // Log specific details about the error if necessary
    return []; // Return an empty array as the default value
  }
};

export default loadPageConfiguration;
